



























import { useConfig } from '~/composables'; 
import { defineComponent } from '@nuxtjs/composition-api'
import { PropType } from 'vue';
import { getTagColor } from '~/utils/solepro/products';
import { ProductBox } from '~/utils/types/Product';

export default defineComponent({
    props: {
        product: {
            type: Object as PropType<ProductBox>,
            required: true
        },
        trackEvent: {
            type: Function
        },
        classes:{
            type: String,
            default:''
        }
    },
    setup(){
        const { config } = useConfig();
        return {
            getTagColor,
            storeCode: config.value.store_code
        }
    },
    methods: {
        trackLink() {
            this.trackEvent(this.product, null)
            location.href = `/${this.storeCode}/${this.product.url_key + this.product.url_suffix}`;
        }
    }
})
